import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { FIELD_DESCRIPTION, FIELD_TEXT, FIELD_TEXTAREA, FIELD_TITLE, FIELD } from 'constants/fields';
import React, { Component } from 'react';
import { Field as FormField } from 'redux-form';
import './Field.scss';
import { Editor } from 'UI/Inputs';
var Field = /*#__PURE__*/function (_Component) {
  function Field() {
    var _this;
    _classCallCheck(this, Field);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Field, [].concat(args));
    _defineProperty(_this, "getFieldProps", function () {
      switch (_this.props.type) {
        case FIELD_TEXT:
          return {
            component: 'input',
            type: 'text',
            name: _this.props.name,
            placeholder: _this.props.placeholder,
            disabled: _this.props.disabled != null ? _this.props.disabled : false
          };
        case FIELD_TEXTAREA:
          return {
            component: Editor,
            name: _this.props.name,
            placeholder: _this.props.placeholder,
            disabled: _this.props.disabled != null ? _this.props.disabled : false
          };
        default:
          return {};
      }
    });
    return _this;
  }
  _inherits(Field, _Component);
  return _createClass(Field, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "form-row field"
      }, this.props.type == FIELD_TITLE ? /*#__PURE__*/React.createElement("div", {
        className: "input-label"
      }, this.props.value) : null, this.props.type == FIELD_DESCRIPTION ? /*#__PURE__*/React.createElement("div", null, this.props.value) : null, this.props.type == FIELD_TEXT || this.props.type == FIELD_TEXTAREA ? /*#__PURE__*/React.createElement("div", {
        className: "input-field"
      }, /*#__PURE__*/React.createElement(FormField, this.getFieldProps())) : null);
    }
  }]);
}(Component);
export default Field;